import * as z from "zod";

export const formSchema = z.object({
  // General Info
  centerName: z.string().min(2, "Il nome del centro è obbligatorio"),
  ownerName: z.string().min(2, "Il nome del titolare è obbligatorio"),
  phoneNumber: z.string().min(10, "Inserisci un numero valido"),
  email: z.string().email("Inserisci un'email valida"),
  address: z.string().min(5, "L'indirizzo è obbligatorio"),
  city: z.string().min(2, "La città è obbligatoria"),
  province: z.string().min(2, "La provincia è obbligatoria"),
  zipCode: z.string().min(5, "Il CAP è obbligatorio"),
  googleMapsLink: z.string().optional(),
  website: z.string().optional(),
  landmarks: z.string().optional(),

  // Accessi Facebook
  facebookEmail: z.string().email("Inserisci un'email valida"),
  facebookPassword: z.string().min(1, "La password è obbligatoria"),

  // Business
  employeeCount: z.string().min(1, "Indica il numero di dipendenti"),
  cabinCount: z.string().min(1, "Indica il numero di cabine"),
  yearsInBusiness: z.enum(["under_1", "1_to_3", "3_to_7", "over_7"], {
    required_error: "Seleziona da quanti anni è aperto il centro",
  }),
  centerZone: z.enum(["city_center", "semi_center", "suburb", "small_town"], {
    required_error: "Seleziona la zona del centro",
  }),
  clientsLast12Months: z.enum(["under_200", "200_500", "500_1000", "1000_2000", "over_2000"], {
    required_error: "Seleziona un'opzione",
  }),
  databaseSize: z.enum(["under_500", "500_1000", "1000_2000", "2000_5000", "over_5000", "paper_only"], {
    required_error: "Seleziona un'opzione",
  }),
  salesResponsible: z.array(z.string()).min(1, "Seleziona almeno un'opzione"),
  sellsPathsOrCards: z.enum(["paths", "cards", "both"], {
    required_error: "Seleziona un'opzione",
  }),
  hasFinancing: z.enum(["yes", "no"], {
    required_error: "Seleziona un'opzione",
  }),
  financingProviders: z.array(z.string()).optional(),
  hasProprietaryMethod: z.enum(["yes", "no"], {
    required_error: "Seleziona un'opzione",
  }),
  proprietaryMethodName: z.string().optional(),
  centerSpecialization: z.enum(["basic", "face", "body", "advanced", "epilation_laser"], {
    required_error: "Seleziona la specializzazione",
  }),
  specializedCompetitors: z.string().min(2, "Indica almeno un competitor"),
  pricePositioning: z.enum(["cheaper", "same", "premium"], {
    required_error: "Seleziona il posizionamento",
  }),
  parkingEase: z.enum(["very_easy", "easy", "neutral", "difficult", "very_difficult"], {
    required_error: "Seleziona un'opzione",
  }),
  socialAdsExperience: z.enum(["yes", "first_time"], {
    required_error: "Seleziona un'opzione",
  }),
  marketingAgencyExperience: z.enum(["yes", "no"], {
    required_error: "Seleziona un'opzione",
  }),
  monthlyRevenueBeforeUs: z.enum(["under_5k", "5k_10k", "10k_20k", "20k_40k", "over_40k"], {
    required_error: "Seleziona una fascia di fatturato",
  }),

  // Treatments
  mainTreatment: z.string().min(10, "Descrivi il trattamento principale"),
  treatmentReason: z.string().min(10, "Spiega il motivo della promozione"),
  differentiators: z.string().min(10, "Descrivi cosa ti differenzia"),
  shortTermResults: z.string().min(10, "Descrivi i risultati a breve termine"),
  longTermResults: z.string().optional(),
  recommendations: z.string().optional(),
  sessionDuration: z.string().optional(),

  // Clientele
  openingHours: z.string().min(5, "Indica gli orari di apertura"),
  clientRadius: z.string().min(1, "Indica il raggio d'azione"),

  // Communication
  appearInAds: z.string().min(2, "Specifica la tua disponibilità"),
  voiceInAds: z.string().optional(),

  // Offers
  currentOffer: z.string().optional(),
  reasonForCollaboration: z.string().min(10, "Spiega perché hai scelto di collaborare"),
  expectations: z.string().min(10, "Descrivi le tue aspettative"),
  doubts: z.string().optional(),
});
